export default (scopes, id, data) =>
	scopes.map((scope) => {
		const {id: scopeId, subScopes} = scope;
		if (scopeId === id) {
			return {...scope, taskData: data};
		}
		if (subScopes?.length !== 0 && subScopes?.some((s) => s.id === id)) {
			const newSubScopes = subScopes.map((subScope) => {
				const {id: subScopeId} = subScope;
				if (subScopeId === id) {
					return {...subScope, taskData: data};
				}
				return {...subScope};
			});
			return {...scope, subScopes: [...newSubScopes]};
		}
		return {...scope};
	});
